import PropTypes from 'prop-types';
import React from 'react';
import {
  IconArrowRight,
  IconArrowUp,
  IconPlus,
  IconX,
} from '@tabler/icons-react';

interface Props {
  size: 'md' | 'xl' | 'lg' | 'sm';
  icon:
    | 'icon-leading'
    | 'only'
    | 'country'
    | 'avatar'
    | 'false'
    | 'dot'
    | 'icon-trailing'
    | 'x-close';
  color:
    | 'warning'
    | 'blue-light'
    | 'blue-gray'
    | 'gray'
    | 'success'
    | 'primary'
    | 'blue'
    | 'ros'
    | 'orange'
    | 'pink'
    | 'error'
    | 'purple'
    | 'indigo';
  outline: boolean;
  className: any;
  textClassName: any;
  text: string;
}

export const Badge = ({
  size,
  icon,
  color,
  outline,
  className,
  textClassName,
  text = 'Label',
}: Props): JSX.Element => {
  return (
    <div
      className={`inline-flex items-center rounded-2xl relative ${outline ? 'border-[1.5px] border-solid' : ''} ${
        outline && color === 'primary'
          ? 'border-[#4298b0]'
          : color === 'warning' && outline
            ? 'border-[#e67a0f]'
            : outline && color === 'success'
              ? 'border-[#3d9e5f]'
              : outline && color === 'blue-gray'
                ? 'border-[#ff427d]'
                : outline && color === 'blue-light'
                  ? 'border-blue-light600'
                  : color === 'indigo' && outline
                    ? 'border-indigo-600'
                    : outline && color === 'purple'
                      ? 'border-purple-600'
                      : color === 'blue' && outline
                        ? 'border-blue-600'
                        : color === 'pink' && outline
                          ? 'border-pink-600'
                          : outline && color === 'ros'
                            ? 'border-ros-600'
                            : color === 'orange' && outline
                              ? 'border-orange-dark-600'
                              : outline && color === 'error'
                                ? 'border-[#e54342]'
                                : color === 'gray' && outline
                                  ? 'border-[#475467]'
                                  : ''
      } ${
        (icon === 'dot' && size === 'sm') ||
        (icon === 'icon-leading' && size === 'lg') ||
        (icon === 'icon-leading' && size === 'md') ||
        (icon === 'icon-leading' && size === 'sm') ||
        icon === 'icon-trailing' ||
        icon === 'only' ||
        (icon === 'x-close' && size === 'lg') ||
        (icon === 'x-close' && size === 'md') ||
        (icon === 'x-close' && size === 'sm') ||
        size === 'xl'
          ? 'gap-1'
          : icon === 'avatar' ||
              icon === 'country' ||
              (icon === 'dot' && size === 'lg') ||
              (icon === 'dot' && size === 'md')
            ? 'gap-1.5'
            : ''
      } ${!outline ? 'mix-blend-multiply' : ''} ${
        size === 'sm' && icon === 'false'
          ? 'px-2 py-0.5'
          : size === 'sm' && ['dot', 'icon-leading'].includes(icon)
            ? 'pl-1.5 pr-2 py-0.5'
            : size === 'sm' && ['icon-trailing', 'x-close'].includes(icon)
              ? 'pl-2 pr-1.5 py-0.5'
              : size === 'sm' && icon === 'only'
                ? 'p-1'
                : size === 'sm' && ['avatar', 'country'].includes(icon)
                  ? 'pl-[3px] pr-2 py-0.5'
                  : size === 'md' && icon === 'false'
                    ? 'px-2.5 py-0.5'
                    : size === 'md' && ['dot', 'icon-leading'].includes(icon)
                      ? 'pl-2 pr-2.5 py-0.5'
                      : icon === 'x-close' && size === 'md'
                        ? 'pl-2.5 pr-2 py-0.5'
                        : icon === 'icon-trailing' && size === 'md'
                          ? 'pl-2.5 pr-1.5 py-0.5'
                          : size === 'md' && icon === 'only'
                            ? 'p-1.5'
                            : size === 'md' &&
                                ['avatar', 'country'].includes(icon)
                              ? 'pl-1 pr-2.5 py-0.5'
                              : size === 'lg' && icon === 'false'
                                ? 'px-3 py-1'
                                : (icon === 'dot' && size === 'lg') ||
                                    (icon === 'icon-leading' &&
                                      size === 'lg') ||
                                    (icon === 'icon-leading' && size === 'xl')
                                  ? 'pl-2.5 pr-3 py-1'
                                  : (icon === 'icon-trailing' &&
                                        size === 'lg') ||
                                      (icon === 'x-close' && size === 'lg') ||
                                      (icon === 'x-close' && size === 'xl')
                                    ? 'pl-3 pr-2.5 py-1'
                                    : size === 'lg' && icon === 'only'
                                      ? 'p-2'
                                      : size === 'lg' &&
                                          ['avatar', 'country'].includes(icon)
                                        ? 'pl-1.5 pr-3 py-1'
                                        : ''
      } ${
        !outline && color === 'primary'
          ? 'bg-[#d3ecf3]'
          : !outline && color === 'warning'
            ? 'bg-[#fff3e7]'
            : !outline && color === 'success'
              ? 'bg-[#ecf7f0]'
              : !outline && color === 'blue-gray'
                ? 'bg-[#ffeef3]'
                : !outline && color === 'blue-light'
                  ? 'bg-[#cadfd4]'
                  : color === 'indigo' && !outline
                    ? 'bg-indigo-50'
                    : !outline && color === 'purple'
                      ? 'bg-purple-50'
                      : color === 'blue' && !outline
                        ? 'bg-blue-50'
                        : color === 'pink' && !outline
                          ? 'bg-pink-50'
                          : !outline && color === 'ros'
                            ? 'bg-ros-50'
                            : !outline && color === 'orange'
                              ? 'bg-orange-dark-50'
                              : !outline && color === 'error'
                                ? 'bg-[#ffeded]'
                                : color === 'gray' && !outline
                                  ? 'bg-[#f2f4f7]'
                                  : ''
      } ${className}`}
    >
      {icon === 'false' && (
        <div
          className={`w-fit text-center whitespace-nowrap relative ${
            size === 'sm'
              ? 'font-text-xs-medium'
              : ['lg', 'md'].includes(size)
                ? 'font-text-sm-medium'
                : ''
          } ${
            size === 'sm'
              ? 'tracking-[var(--text-xs-medium-letter-spacing)]'
              : ['lg', 'md'].includes(size)
                ? 'tracking-[var(--text-sm-medium-letter-spacing)]'
                : ''
          } ${
            size === 'sm'
              ? '[font-style:var(--text-xs-medium-font-style)]'
              : ['lg', 'md'].includes(size)
                ? '[font-style:var(--text-sm-medium-font-style)]'
                : ''
          } ${
            size === 'sm'
              ? 'text-[length:var(--text-xs-medium-font-size)]'
              : ['lg', 'md'].includes(size)
                ? 'text-[length:var(--text-sm-medium-font-size)]'
                : ''
          } ${outline ? 'mt-[-1.50px]' : ''} ${
            color === 'primary'
              ? 'text-[#377d91]'
              : color === 'warning'
                ? 'text-[#cc6d0e]'
                : color === 'success'
                  ? 'text-[#368c54]'
                  : color === 'blue-gray'
                    ? 'text-[#ff3172]'
                    : outline && color === 'blue-light'
                      ? 'text-blue-light700'
                      : color === 'indigo'
                        ? 'text-indigo-700'
                        : color === 'purple'
                          ? 'text-purple-700'
                          : color === 'blue'
                            ? 'text-blue-700'
                            : color === 'pink'
                              ? 'text-pink-700'
                              : color === 'ros'
                                ? 'text-ros-700'
                                : color === 'orange'
                                  ? 'text-orange-700'
                                  : color === 'error'
                                    ? 'text-[#cb3b3a]'
                                    : color === 'gray'
                                      ? 'text-[#344054]'
                                      : 'text-[#1d583a]'
          } ${
            size === 'sm'
              ? 'font-[number:var(--text-xs-medium-font-weight)]'
              : ['lg', 'md'].includes(size)
                ? 'font-[number:var(--text-sm-medium-font-weight)]'
                : ''
          } ${
            size === 'sm'
              ? 'leading-[var(--text-xs-medium-line-height)]'
              : ['lg', 'md'].includes(size)
                ? 'leading-[var(--text-sm-medium-line-height)]'
                : ''
          } ${textClassName}`}
        >
          {text}
        </div>
      )}

      {['avatar', 'dot'].includes(icon) && (
        <div
          className={`relative ${icon === 'avatar' ? 'w-4' : 'w-2'} ${icon === 'avatar' ? 'bg-cover' : ''} ${
            icon === 'avatar' ? 'h-4' : 'h-2'
          } ${
            !outline &&
            icon === 'avatar' &&
            size === 'sm' &&
            color === 'primary'
              ? 'bg-[url(/avatar.png)]'
              : icon === 'avatar' &&
                  size === 'sm' &&
                  color === 'primary' &&
                  outline
                ? 'bg-[url(/image.png)]'
                : !outline &&
                    color === 'warning' &&
                    icon === 'avatar' &&
                    size === 'sm'
                  ? 'bg-[url(/avatar-2.png)]'
                  : color === 'warning' &&
                      icon === 'avatar' &&
                      size === 'sm' &&
                      outline
                    ? 'bg-[url(/avatar-3.png)]'
                    : !outline &&
                        icon === 'avatar' &&
                        size === 'sm' &&
                        color === 'success'
                      ? 'bg-[url(/avatar-4.png)]'
                      : icon === 'avatar' &&
                          size === 'sm' &&
                          color === 'success' &&
                          outline
                        ? 'bg-[url(/avatar-5.png)]'
                        : !outline &&
                            icon === 'avatar' &&
                            size === 'sm' &&
                            color === 'blue-gray'
                          ? 'bg-[url(/avatar-6.png)]'
                          : icon === 'avatar' &&
                              size === 'sm' &&
                              color === 'blue-gray' &&
                              outline
                            ? 'bg-[url(/avatar-7.png)]'
                            : !outline &&
                                icon === 'avatar' &&
                                size === 'sm' &&
                                color === 'blue-light'
                              ? 'bg-[url(/avatar-8.png)]'
                              : icon === 'avatar' &&
                                  size === 'sm' &&
                                  color === 'blue-light' &&
                                  outline
                                ? 'bg-[url(/avatar-9.png)]'
                                : color === 'indigo' &&
                                    !outline &&
                                    icon === 'avatar' &&
                                    size === 'sm'
                                  ? 'bg-[url(/avatar-10.png)]'
                                  : color === 'indigo' &&
                                      icon === 'avatar' &&
                                      size === 'sm' &&
                                      outline
                                    ? 'bg-[url(/avatar-11.png)]'
                                    : !outline &&
                                        icon === 'avatar' &&
                                        size === 'sm' &&
                                        color === 'purple'
                                      ? 'bg-[url(/avatar-12.png)]'
                                      : icon === 'avatar' &&
                                          size === 'sm' &&
                                          color === 'purple' &&
                                          outline
                                        ? 'bg-[url(/avatar-13.png)]'
                                        : color === 'blue' &&
                                            !outline &&
                                            icon === 'avatar' &&
                                            size === 'sm'
                                          ? 'bg-[url(/avatar-14.png)]'
                                          : color === 'blue' &&
                                              icon === 'avatar' &&
                                              size === 'sm' &&
                                              outline
                                            ? 'bg-[url(/avatar-15.png)]'
                                            : color === 'pink' &&
                                                !outline &&
                                                icon === 'avatar' &&
                                                size === 'sm'
                                              ? 'bg-[url(/avatar-16.png)]'
                                              : color === 'pink' &&
                                                  icon === 'avatar' &&
                                                  size === 'sm' &&
                                                  outline
                                                ? 'bg-[url(/avatar-17.png)]'
                                                : !outline &&
                                                    icon === 'avatar' &&
                                                    size === 'sm' &&
                                                    color === 'ros'
                                                  ? 'bg-[url(/avatar-18.png)]'
                                                  : icon === 'avatar' &&
                                                      size === 'sm' &&
                                                      color === 'ros' &&
                                                      outline
                                                    ? 'bg-[url(/avatar-19.png)]'
                                                    : !outline &&
                                                        color === 'orange' &&
                                                        icon === 'avatar' &&
                                                        size === 'sm'
                                                      ? 'bg-[url(/avatar-20.png)]'
                                                      : color === 'orange' &&
                                                          icon === 'avatar' &&
                                                          size === 'sm' &&
                                                          outline
                                                        ? 'bg-[url(/avatar-21.png)]'
                                                        : !outline &&
                                                            icon === 'avatar' &&
                                                            size === 'sm' &&
                                                            color === 'error'
                                                          ? 'bg-[url(/avatar-22.png)]'
                                                          : icon === 'avatar' &&
                                                              size === 'sm' &&
                                                              color ===
                                                                'error' &&
                                                              outline
                                                            ? 'bg-[url(/avatar-23.png)]'
                                                            : color ===
                                                                  'gray' &&
                                                                icon ===
                                                                  'avatar' &&
                                                                size === 'sm' &&
                                                                !outline
                                                              ? 'bg-[url(/avatar-24.png)]'
                                                              : color ===
                                                                    'gray' &&
                                                                  icon ===
                                                                    'avatar' &&
                                                                  size ===
                                                                    'sm' &&
                                                                  outline
                                                                ? 'bg-[url(/avatar-25.png)]'
                                                                : !outline &&
                                                                    icon ===
                                                                      'avatar' &&
                                                                    size ===
                                                                      'md' &&
                                                                    color ===
                                                                      'primary'
                                                                  ? 'bg-[url(/avatar-26.png)]'
                                                                  : icon ===
                                                                        'avatar' &&
                                                                      size ===
                                                                        'md' &&
                                                                      color ===
                                                                        'primary' &&
                                                                      outline
                                                                    ? 'bg-[url(/avatar-27.png)]'
                                                                    : !outline &&
                                                                        color ===
                                                                          'warning' &&
                                                                        icon ===
                                                                          'avatar' &&
                                                                        size ===
                                                                          'md'
                                                                      ? 'bg-[url(/avatar-28.png)]'
                                                                      : color ===
                                                                            'warning' &&
                                                                          icon ===
                                                                            'avatar' &&
                                                                          size ===
                                                                            'md' &&
                                                                          outline
                                                                        ? 'bg-[url(/avatar-29.png)]'
                                                                        : !outline &&
                                                                            icon ===
                                                                              'avatar' &&
                                                                            size ===
                                                                              'md' &&
                                                                            color ===
                                                                              'success'
                                                                          ? 'bg-[url(/avatar-30.png)]'
                                                                          : icon ===
                                                                                'avatar' &&
                                                                              size ===
                                                                                'md' &&
                                                                              color ===
                                                                                'success' &&
                                                                              outline
                                                                            ? 'bg-[url(/avatar-31.png)]'
                                                                            : !outline &&
                                                                                icon ===
                                                                                  'avatar' &&
                                                                                size ===
                                                                                  'md' &&
                                                                                color ===
                                                                                  'blue-gray'
                                                                              ? 'bg-[url(/avatar-32.png)]'
                                                                              : icon ===
                                                                                    'avatar' &&
                                                                                  size ===
                                                                                    'md' &&
                                                                                  color ===
                                                                                    'blue-gray' &&
                                                                                  outline
                                                                                ? 'bg-[url(/avatar-33.png)]'
                                                                                : !outline &&
                                                                                    icon ===
                                                                                      'avatar' &&
                                                                                    size ===
                                                                                      'md' &&
                                                                                    color ===
                                                                                      'blue-light'
                                                                                  ? 'bg-[url(/avatar-34.png)]'
                                                                                  : icon ===
                                                                                        'avatar' &&
                                                                                      size ===
                                                                                        'md' &&
                                                                                      color ===
                                                                                        'blue-light' &&
                                                                                      outline
                                                                                    ? 'bg-[url(/avatar-35.png)]'
                                                                                    : !outline &&
                                                                                        icon ===
                                                                                          'avatar' &&
                                                                                        size ===
                                                                                          'md' &&
                                                                                        color ===
                                                                                          'purple'
                                                                                      ? 'bg-[url(/avatar-36.png)]'
                                                                                      : icon ===
                                                                                            'avatar' &&
                                                                                          size ===
                                                                                            'md' &&
                                                                                          color ===
                                                                                            'purple' &&
                                                                                          outline
                                                                                        ? 'bg-[url(/avatar-37.png)]'
                                                                                        : color ===
                                                                                              'blue' &&
                                                                                            !outline &&
                                                                                            icon ===
                                                                                              'avatar' &&
                                                                                            size ===
                                                                                              'md'
                                                                                          ? 'bg-[url(/avatar-38.png)]'
                                                                                          : color ===
                                                                                                'blue' &&
                                                                                              icon ===
                                                                                                'avatar' &&
                                                                                              size ===
                                                                                                'md' &&
                                                                                              outline
                                                                                            ? 'bg-[url(/avatar-39.png)]'
                                                                                            : color ===
                                                                                                  'pink' &&
                                                                                                !outline &&
                                                                                                icon ===
                                                                                                  'avatar' &&
                                                                                                size ===
                                                                                                  'md'
                                                                                              ? 'bg-[url(/avatar-40.png)]'
                                                                                              : color ===
                                                                                                    'pink' &&
                                                                                                  icon ===
                                                                                                    'avatar' &&
                                                                                                  size ===
                                                                                                    'md' &&
                                                                                                  outline
                                                                                                ? 'bg-[url(/avatar-41.png)]'
                                                                                                : !outline &&
                                                                                                    icon ===
                                                                                                      'avatar' &&
                                                                                                    size ===
                                                                                                      'md' &&
                                                                                                    color ===
                                                                                                      'ros'
                                                                                                  ? 'bg-[url(/avatar-42.png)]'
                                                                                                  : icon ===
                                                                                                        'avatar' &&
                                                                                                      size ===
                                                                                                        'md' &&
                                                                                                      color ===
                                                                                                        'ros' &&
                                                                                                      outline
                                                                                                    ? 'bg-[url(/avatar-43.png)]'
                                                                                                    : !outline &&
                                                                                                        color ===
                                                                                                          'orange' &&
                                                                                                        icon ===
                                                                                                          'avatar' &&
                                                                                                        size ===
                                                                                                          'md'
                                                                                                      ? 'bg-[url(/avatar-44.png)]'
                                                                                                      : color ===
                                                                                                            'orange' &&
                                                                                                          icon ===
                                                                                                            'avatar' &&
                                                                                                          size ===
                                                                                                            'md' &&
                                                                                                          outline
                                                                                                        ? 'bg-[url(/avatar-45.png)]'
                                                                                                        : !outline &&
                                                                                                            icon ===
                                                                                                              'avatar' &&
                                                                                                            size ===
                                                                                                              'md' &&
                                                                                                            color ===
                                                                                                              'error'
                                                                                                          ? 'bg-[url(/avatar-46.png)]'
                                                                                                          : icon ===
                                                                                                                'avatar' &&
                                                                                                              size ===
                                                                                                                'md' &&
                                                                                                              color ===
                                                                                                                'error' &&
                                                                                                              outline
                                                                                                            ? 'bg-[url(/avatar-47.png)]'
                                                                                                            : color ===
                                                                                                                  'gray' &&
                                                                                                                icon ===
                                                                                                                  'avatar' &&
                                                                                                                size ===
                                                                                                                  'md' &&
                                                                                                                !outline
                                                                                                              ? 'bg-[url(/avatar-48.png)]'
                                                                                                              : color ===
                                                                                                                    'gray' &&
                                                                                                                  icon ===
                                                                                                                    'avatar' &&
                                                                                                                  size ===
                                                                                                                    'md' &&
                                                                                                                  outline
                                                                                                                ? 'bg-[url(/avatar-49.png)]'
                                                                                                                : size ===
                                                                                                                      'lg' &&
                                                                                                                    icon ===
                                                                                                                      'avatar' &&
                                                                                                                    !outline &&
                                                                                                                    color ===
                                                                                                                      'primary'
                                                                                                                  ? 'bg-[url(/avatar-50.png)]'
                                                                                                                  : size ===
                                                                                                                        'lg' &&
                                                                                                                      icon ===
                                                                                                                        'avatar' &&
                                                                                                                      color ===
                                                                                                                        'primary' &&
                                                                                                                      outline
                                                                                                                    ? 'bg-[url(/avatar-51.png)]'
                                                                                                                    : size ===
                                                                                                                          'lg' &&
                                                                                                                        color ===
                                                                                                                          'warning' &&
                                                                                                                        icon ===
                                                                                                                          'avatar' &&
                                                                                                                        !outline
                                                                                                                      ? 'bg-[url(/avatar-52.png)]'
                                                                                                                      : size ===
                                                                                                                            'lg' &&
                                                                                                                          color ===
                                                                                                                            'warning' &&
                                                                                                                          icon ===
                                                                                                                            'avatar' &&
                                                                                                                          outline
                                                                                                                        ? 'bg-[url(/avatar-53.png)]'
                                                                                                                        : size ===
                                                                                                                              'lg' &&
                                                                                                                            icon ===
                                                                                                                              'avatar' &&
                                                                                                                            color ===
                                                                                                                              'success' &&
                                                                                                                            !outline
                                                                                                                          ? 'bg-[url(/avatar-54.png)]'
                                                                                                                          : size ===
                                                                                                                                'lg' &&
                                                                                                                              icon ===
                                                                                                                                'avatar' &&
                                                                                                                              color ===
                                                                                                                                'success' &&
                                                                                                                              outline
                                                                                                                            ? 'bg-[url(/avatar-55.png)]'
                                                                                                                            : size ===
                                                                                                                                  'lg' &&
                                                                                                                                icon ===
                                                                                                                                  'avatar' &&
                                                                                                                                color ===
                                                                                                                                  'blue-gray' &&
                                                                                                                                !outline
                                                                                                                              ? 'bg-[url(/avatar-56.png)]'
                                                                                                                              : size ===
                                                                                                                                    'lg' &&
                                                                                                                                  icon ===
                                                                                                                                    'avatar' &&
                                                                                                                                  color ===
                                                                                                                                    'blue-gray' &&
                                                                                                                                  outline
                                                                                                                                ? 'bg-[url(/avatar-57.png)]'
                                                                                                                                : size ===
                                                                                                                                      'lg' &&
                                                                                                                                    icon ===
                                                                                                                                      'avatar' &&
                                                                                                                                    color ===
                                                                                                                                      'blue-light' &&
                                                                                                                                    !outline
                                                                                                                                  ? 'bg-[url(/avatar-58.png)]'
                                                                                                                                  : size ===
                                                                                                                                        'lg' &&
                                                                                                                                      icon ===
                                                                                                                                        'avatar' &&
                                                                                                                                      color ===
                                                                                                                                        'blue-light' &&
                                                                                                                                      outline
                                                                                                                                    ? 'bg-[url(/avatar-59.png)]'
                                                                                                                                    : color ===
                                                                                                                                          'indigo' &&
                                                                                                                                        size ===
                                                                                                                                          'lg' &&
                                                                                                                                        icon ===
                                                                                                                                          'avatar' &&
                                                                                                                                        !outline
                                                                                                                                      ? 'bg-[url(/avatar-60.png)]'
                                                                                                                                      : color ===
                                                                                                                                            'indigo' &&
                                                                                                                                          size ===
                                                                                                                                            'lg' &&
                                                                                                                                          icon ===
                                                                                                                                            'avatar' &&
                                                                                                                                          outline
                                                                                                                                        ? 'bg-[url(/avatar-61.png)]'
                                                                                                                                        : size ===
                                                                                                                                              'lg' &&
                                                                                                                                            icon ===
                                                                                                                                              'avatar' &&
                                                                                                                                            color ===
                                                                                                                                              'purple' &&
                                                                                                                                            !outline
                                                                                                                                          ? 'bg-[url(/avatar-62.png)]'
                                                                                                                                          : size ===
                                                                                                                                                'lg' &&
                                                                                                                                              icon ===
                                                                                                                                                'avatar' &&
                                                                                                                                              color ===
                                                                                                                                                'purple' &&
                                                                                                                                              outline
                                                                                                                                            ? 'bg-[url(/avatar-63.png)]'
                                                                                                                                            : color ===
                                                                                                                                                  'blue' &&
                                                                                                                                                size ===
                                                                                                                                                  'lg' &&
                                                                                                                                                icon ===
                                                                                                                                                  'avatar' &&
                                                                                                                                                !outline
                                                                                                                                              ? 'bg-[url(/avatar-64.png)]'
                                                                                                                                              : color ===
                                                                                                                                                    'blue' &&
                                                                                                                                                  size ===
                                                                                                                                                    'lg' &&
                                                                                                                                                  icon ===
                                                                                                                                                    'avatar' &&
                                                                                                                                                  outline
                                                                                                                                                ? 'bg-[url(/avatar-65.png)]'
                                                                                                                                                : color ===
                                                                                                                                                      'pink' &&
                                                                                                                                                    size ===
                                                                                                                                                      'lg' &&
                                                                                                                                                    icon ===
                                                                                                                                                      'avatar' &&
                                                                                                                                                    !outline
                                                                                                                                                  ? 'bg-[url(/avatar-66.png)]'
                                                                                                                                                  : color ===
                                                                                                                                                        'pink' &&
                                                                                                                                                      size ===
                                                                                                                                                        'lg' &&
                                                                                                                                                      icon ===
                                                                                                                                                        'avatar' &&
                                                                                                                                                      outline
                                                                                                                                                    ? 'bg-[url(/avatar-67.png)]'
                                                                                                                                                    : size ===
                                                                                                                                                          'lg' &&
                                                                                                                                                        icon ===
                                                                                                                                                          'avatar' &&
                                                                                                                                                        color ===
                                                                                                                                                          'ros' &&
                                                                                                                                                        !outline
                                                                                                                                                      ? 'bg-[url(/avatar-68.png)]'
                                                                                                                                                      : size ===
                                                                                                                                                            'lg' &&
                                                                                                                                                          icon ===
                                                                                                                                                            'avatar' &&
                                                                                                                                                          color ===
                                                                                                                                                            'ros' &&
                                                                                                                                                          outline
                                                                                                                                                        ? 'bg-[url(/avatar-69.png)]'
                                                                                                                                                        : size ===
                                                                                                                                                              'lg' &&
                                                                                                                                                            color ===
                                                                                                                                                              'orange' &&
                                                                                                                                                            icon ===
                                                                                                                                                              'avatar' &&
                                                                                                                                                            !outline
                                                                                                                                                          ? 'bg-[url(/avatar-70.png)]'
                                                                                                                                                          : size ===
                                                                                                                                                                'lg' &&
                                                                                                                                                              color ===
                                                                                                                                                                'orange' &&
                                                                                                                                                              icon ===
                                                                                                                                                                'avatar' &&
                                                                                                                                                              outline
                                                                                                                                                            ? 'bg-[url(/avatar-71.png)]'
                                                                                                                                                            : size ===
                                                                                                                                                                  'lg' &&
                                                                                                                                                                icon ===
                                                                                                                                                                  'avatar' &&
                                                                                                                                                                color ===
                                                                                                                                                                  'error' &&
                                                                                                                                                                !outline
                                                                                                                                                              ? 'bg-[url(/avatar-72.png)]'
                                                                                                                                                              : size ===
                                                                                                                                                                    'lg' &&
                                                                                                                                                                  icon ===
                                                                                                                                                                    'avatar' &&
                                                                                                                                                                  color ===
                                                                                                                                                                    'error' &&
                                                                                                                                                                  outline
                                                                                                                                                                ? 'bg-[url(/avatar-73.png)]'
                                                                                                                                                                : size ===
                                                                                                                                                                      'lg' &&
                                                                                                                                                                    color ===
                                                                                                                                                                      'gray' &&
                                                                                                                                                                    icon ===
                                                                                                                                                                      'avatar' &&
                                                                                                                                                                    !outline
                                                                                                                                                                  ? 'bg-[url(/avatar-74.png)]'
                                                                                                                                                                  : size ===
                                                                                                                                                                        'lg' &&
                                                                                                                                                                      color ===
                                                                                                                                                                        'gray' &&
                                                                                                                                                                      icon ===
                                                                                                                                                                        'avatar' &&
                                                                                                                                                                      outline
                                                                                                                                                                    ? 'bg-[url(/avatar-75.png)]'
                                                                                                                                                                    : color ===
                                                                                                                                                                          'indigo' &&
                                                                                                                                                                        !outline &&
                                                                                                                                                                        icon ===
                                                                                                                                                                          'avatar' &&
                                                                                                                                                                        size ===
                                                                                                                                                                          'md'
                                                                                                                                                                      ? 'bg-[url(/avatar-76.png)]'
                                                                                                                                                                      : color ===
                                                                                                                                                                            'indigo' &&
                                                                                                                                                                          icon ===
                                                                                                                                                                            'avatar' &&
                                                                                                                                                                          size ===
                                                                                                                                                                            'md' &&
                                                                                                                                                                          outline
                                                                                                                                                                        ? 'bg-[url(/avatar-77.png)]'
                                                                                                                                                                        : ''
          } ${icon === 'avatar' ? 'rounded-lg' : ''} ${icon === 'avatar' ? 'bg-[50%_50%]' : ''}`}
        >
          {icon === 'dot' && (
            <div
              className={`w-1.5 left-px top-px h-1.5 rounded-[3px] relative ${
                outline && color === 'primary'
                  ? 'bg-[#4298b0]'
                  : !outline && color === 'warning'
                    ? 'bg-[#ff8811]'
                    : color === 'warning' && outline
                      ? 'bg-[#e67a0f]'
                      : !outline && color === 'success'
                        ? 'bg-[#44af69]'
                        : outline && color === 'success'
                          ? 'bg-[#3d9e5f]'
                          : color === 'blue-gray'
                            ? 'bg-[#ff5389]'
                            : !outline && color === 'blue-light'
                              ? 'bg-[#1d583a]'
                              : outline && color === 'blue-light'
                                ? 'bg-blue-light500'
                                : color === 'indigo'
                                  ? 'bg-indigo-500'
                                  : color === 'purple'
                                    ? 'bg-purple-500'
                                    : color === 'blue'
                                      ? 'bg-blue-500'
                                      : color === 'pink'
                                        ? 'bg-pink-500'
                                        : color === 'ros'
                                          ? 'bg-ros-500'
                                          : color === 'orange'
                                            ? 'bg-orange-500'
                                            : !outline && color === 'error'
                                              ? 'bg-[#fe4a49]'
                                              : outline && color === 'error'
                                                ? 'bg-[#e54342]'
                                                : color === 'gray' && !outline
                                                  ? 'bg-[#667085]'
                                                  : color === 'gray' && outline
                                                    ? 'bg-[#475467]'
                                                    : 'bg-[#4eb3cf]'
              }`}
            />
          )}
        </div>
      )}

      {icon === 'icon-leading' && (
        <IconArrowUp
          className={
            size === 'xl' ? '!relative !w-4 !h-4' : '!relative !w-3 !h-3'
          }
          color={
            outline && color === 'primary'
              ? '#4298B0'
              : !outline && color === 'warning'
                ? '#FF8811'
                : color === 'warning' && outline
                  ? '#E67A0F'
                  : !outline && color === 'success'
                    ? '#44AF69'
                    : outline && color === 'success'
                      ? '#3D9E5F'
                      : color === 'blue-gray'
                        ? '#FF5389'
                        : !outline && color === 'blue-light'
                          ? '#1D583A'
                          : outline && color === 'blue-light'
                            ? '#0BA5EC'
                            : color === 'indigo'
                              ? '#6172F3'
                              : color === 'purple'
                                ? '#7A5AF8'
                                : color === 'blue'
                                  ? '#2E90FA'
                                  : color === 'pink'
                                    ? '#EE46BC'
                                    : color === 'ros'
                                      ? '#F63D68'
                                      : color === 'orange'
                                        ? '#EF6820'
                                        : !outline && color === 'error'
                                          ? '#FE4A49'
                                          : outline && color === 'error'
                                            ? '#E54342'
                                            : color === 'gray' && !outline
                                              ? '#667085'
                                              : color === 'gray' && outline
                                                ? '#475467'
                                                : '#4EB3CF'
          }
        />
      )}

      {['avatar', 'dot', 'icon-leading', 'icon-trailing', 'x-close'].includes(
        icon
      ) && (
        <div
          className={`w-fit relative text-center whitespace-nowrap ${
            size === 'sm'
              ? 'font-text-xs-medium'
              : size === 'xl'
                ? 'font-text-md-medium'
                : 'font-text-sm-medium'
          } ${
            size === 'sm'
              ? 'tracking-[var(--text-xs-medium-letter-spacing)]'
              : size === 'xl'
                ? 'tracking-[var(--text-md-medium-letter-spacing)]'
                : 'tracking-[var(--text-sm-medium-letter-spacing)]'
          } ${
            size === 'sm'
              ? '[font-style:var(--text-xs-medium-font-style)]'
              : size === 'xl'
                ? '[font-style:var(--text-md-medium-font-style)]'
                : '[font-style:var(--text-sm-medium-font-style)]'
          } ${
            size === 'sm'
              ? 'text-[length:var(--text-xs-medium-font-size)]'
              : size === 'xl'
                ? 'text-[length:var(--text-md-medium-font-size)]'
                : 'text-[length:var(--text-sm-medium-font-size)]'
          } ${outline ? 'mt-[-1.50px]' : ''} ${
            color === 'primary'
              ? 'text-[#377d91]'
              : color === 'warning'
                ? 'text-[#cc6d0e]'
                : color === 'success'
                  ? 'text-[#368c54]'
                  : color === 'blue-gray'
                    ? 'text-[#ff3172]'
                    : outline && color === 'blue-light'
                      ? 'text-blue-light700'
                      : color === 'indigo'
                        ? 'text-indigo-700'
                        : color === 'purple'
                          ? 'text-purple-700'
                          : color === 'blue'
                            ? 'text-blue-700'
                            : color === 'pink'
                              ? 'text-pink-700'
                              : color === 'ros'
                                ? 'text-ros-700'
                                : color === 'orange'
                                  ? 'text-orange-700'
                                  : color === 'error'
                                    ? 'text-[#cb3b3a]'
                                    : color === 'gray'
                                      ? 'text-[#344054]'
                                      : 'text-[#1d583a]'
          } ${
            size === 'sm'
              ? 'font-[number:var(--text-xs-medium-font-weight)]'
              : size === 'xl'
                ? 'font-[number:var(--text-md-medium-font-weight)]'
                : 'font-[number:var(--text-sm-medium-font-weight)]'
          } ${
            size === 'sm'
              ? 'leading-[var(--text-xs-medium-line-height)]'
              : size === 'xl'
                ? 'leading-[var(--text-md-medium-line-height)]'
                : 'leading-[var(--text-sm-medium-line-height)]'
          }`}
        >
          {text}
        </div>
      )}

      {icon === 'only' && (
        <IconPlus
          className="!relative !w-3 !h-3"
          color={
            outline && color === 'primary'
              ? '#4298B0'
              : !outline && color === 'warning'
                ? '#FF8811'
                : color === 'warning' && outline
                  ? '#E67A0F'
                  : !outline && color === 'success'
                    ? '#44AF69'
                    : outline && color === 'success'
                      ? '#3D9E5F'
                      : color === 'blue-gray'
                        ? '#FF5389'
                        : !outline && color === 'blue-light'
                          ? '#1D583A'
                          : outline && color === 'blue-light'
                            ? '#0BA5EC'
                            : color === 'indigo'
                              ? '#6172F3'
                              : color === 'purple'
                                ? '#7A5AF8'
                                : color === 'blue'
                                  ? '#2E90FA'
                                  : color === 'pink'
                                    ? '#EE46BC'
                                    : color === 'ros'
                                      ? '#F63D68'
                                      : color === 'orange'
                                        ? '#EF6820'
                                        : !outline && color === 'error'
                                          ? '#FE4A49'
                                          : outline && color === 'error'
                                            ? '#E54342'
                                            : color === 'gray' && !outline
                                              ? '#667085'
                                              : color === 'gray' && outline
                                                ? '#475467'
                                                : '#4EB3CF'
          }
        />
      )}

      {icon === 'country' && (
        <>
          <IconArrowRight className="!relative !w-4 !h-4" />
          <div
            className={`w-fit text-center whitespace-nowrap relative ${
              size === 'sm'
                ? 'font-text-xs-medium'
                : ['lg', 'md'].includes(size)
                  ? 'font-text-sm-medium'
                  : ''
            } ${
              size === 'sm'
                ? 'tracking-[var(--text-xs-medium-letter-spacing)]'
                : ['lg', 'md'].includes(size)
                  ? 'tracking-[var(--text-sm-medium-letter-spacing)]'
                  : ''
            } ${
              size === 'sm'
                ? '[font-style:var(--text-xs-medium-font-style)]'
                : ['lg', 'md'].includes(size)
                  ? '[font-style:var(--text-sm-medium-font-style)]'
                  : ''
            } ${
              size === 'sm'
                ? 'text-[length:var(--text-xs-medium-font-size)]'
                : ['lg', 'md'].includes(size)
                  ? 'text-[length:var(--text-sm-medium-font-size)]'
                  : ''
            } ${outline ? 'mt-[-1.50px]' : ''} ${
              color === 'primary'
                ? 'text-[#377d91]'
                : color === 'warning'
                  ? 'text-[#cc6d0e]'
                  : color === 'success'
                    ? 'text-[#368c54]'
                    : color === 'blue-gray'
                      ? 'text-[#ff3172]'
                      : outline && color === 'blue-light'
                        ? 'text-blue-light700'
                        : color === 'indigo'
                          ? 'text-indigo-700'
                          : color === 'purple'
                            ? 'text-purple-700'
                            : color === 'blue'
                              ? 'text-blue-700'
                              : color === 'pink'
                                ? 'text-pink-700'
                                : color === 'ros'
                                  ? 'text-ros-700'
                                  : color === 'orange'
                                    ? 'text-orange-700'
                                    : color === 'error'
                                      ? 'text-[#cb3b3a]'
                                      : color === 'gray'
                                        ? 'text-[#344054]'
                                        : 'text-[#1d583a]'
            } ${
              size === 'sm'
                ? 'font-[number:var(--text-xs-medium-font-weight)]'
                : ['lg', 'md'].includes(size)
                  ? 'font-[number:var(--text-sm-medium-font-weight)]'
                  : ''
            } ${
              size === 'sm'
                ? 'leading-[var(--text-xs-medium-line-height)]'
                : ['lg', 'md'].includes(size)
                  ? 'leading-[var(--text-sm-medium-line-height)]'
                  : ''
            }`}
          >
            {text}
          </div>
        </>
      )}

      {icon === 'x-close' && (
        <IconX
          className="!relative !w-3 !h-3"
          color={
            color === 'primary'
              ? '#4298B0'
              : color === 'warning' && outline
                ? '#E67A0F'
                : !outline && color === 'success'
                  ? '#44AF69'
                  : outline && color === 'success'
                    ? '#3D9E5F'
                    : color === 'blue-gray'
                      ? '#FF5389'
                      : !outline && color === 'blue-light'
                        ? '#1D583A'
                        : outline && color === 'blue-light'
                          ? '#0BA5EC'
                          : color === 'indigo'
                            ? '#6172F3'
                            : color === 'purple'
                              ? '#7A5AF8'
                              : color === 'blue'
                                ? '#2E90FA'
                                : color === 'pink'
                                  ? '#EE46BC'
                                  : color === 'ros'
                                    ? '#F63D68'
                                    : color === 'orange'
                                      ? '#EF6820'
                                      : !outline && color === 'error'
                                        ? '#FE4A49'
                                        : outline && color === 'error'
                                          ? '#E54342'
                                          : color === 'gray' && !outline
                                            ? '#667085'
                                            : color === 'gray' && outline
                                              ? '#475467'
                                              : '#FF8811'
          }
        />
      )}

      {icon === 'icon-trailing' && (
        <IconArrowRight
          className="!relative !w-3 !h-3"
          color={
            outline && color === 'primary'
              ? '#4298B0'
              : !outline && color === 'warning'
                ? '#FF8811'
                : color === 'warning' && outline
                  ? '#E67A0F'
                  : !outline && color === 'success'
                    ? '#44AF69'
                    : outline && color === 'success'
                      ? '#3D9E5F'
                      : color === 'blue-gray'
                        ? '#FF5389'
                        : !outline && color === 'blue-light'
                          ? '#1D583A'
                          : outline && color === 'blue-light'
                            ? '#0BA5EC'
                            : color === 'indigo'
                              ? '#6172F3'
                              : color === 'purple'
                                ? '#7A5AF8'
                                : color === 'blue'
                                  ? '#2E90FA'
                                  : color === 'pink'
                                    ? '#EE46BC'
                                    : color === 'ros'
                                      ? '#F63D68'
                                      : color === 'orange'
                                        ? '#EF6820'
                                        : !outline && color === 'error'
                                          ? '#FE4A49'
                                          : outline && color === 'error'
                                            ? '#E54342'
                                            : color === 'gray' && !outline
                                              ? '#667085'
                                              : color === 'gray' && outline
                                                ? '#475467'
                                                : '#4EB3CF'
          }
        />
      )}
    </div>
  );
};

Badge.propTypes = {
  size: PropTypes.oneOf(['md', 'xl', 'lg', 'sm']),
  icon: PropTypes.oneOf([
    'icon-leading',
    'only',
    'country',
    'avatar',
    'false',
    'dot',
    'icon-trailing',
    'x-close',
  ]),
  color: PropTypes.oneOf([
    'warning',
    'blue-light',
    'blue-gray',
    'gray',
    'success',
    'primary',
    'blue',
    'ros',
    'orange',
    'pink',
    'error',
    'purple',
    'indigo',
  ]),
  outline: PropTypes.bool,
  text: PropTypes.string,
};
